<div class="min-h-screen text-sm dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">
  <div class="flex flex-col md:flex-row md:items-end justify-between mb-6 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">ตรวจสอบ Advance จอดฟรี</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        ลาน: <span class="font-bold text-amber-600">{{ selectedSiteName || '—' }}</span>
      </p>
    </div>
  </div>

  <div *ngIf="!selectedSiteId && !isLoading()"
    class="rounded-2xl border border-dashed border-amber-300 bg-amber-50/50 p-8 text-center">
    <p class="font-bold">เลือกลานจากแถบด้านข้างก่อน</p>
  </div>

  <app-pss-loading *ngIf="isLoading()"></app-pss-loading>

  <div *ngIf="selectedSiteId && !isLoading() && !hasGroup"
    class="mb-6 rounded-2xl border border-amber-300 bg-amber-50/70 p-5 text-center">
    <p class="font-bold mb-2">ยังไม่มีกลุ่มสิทธิ์</p>
    <p class="text-sm mb-3">ให้ Admin ตั้งกลุ่มสิทธิ์ก่อนจึงจะตรวจโควต้าได้</p>
    <a routerLink="/system-settings/access-groups" class="text-amber-700 font-bold underline">ไปตั้งกลุ่มสิทธิ์</a>
  </div>

  <div *ngIf="selectedSiteId && !isLoading() && hasGroup" class="max-w-xl space-y-4">
    <!-- Steps -->
    <div class="rounded-2xl border border-slate-100 dark:border-slate-800 bg-white/90 dark:bg-slate-900/90 p-4 text-xs space-y-2">
      <p class="font-bold text-slate-700 dark:text-slate-200 uppercase tracking-wider">ขั้นตอน</p>
      <ol class="list-decimal list-inside space-y-1 text-slate-500 dark:text-slate-400">
        <li>เลือกร้าน + Subscription + จำนวน</li>
        <li>กดตรวจสอบโควต้า</li>
        <li>ผ่านแล้ว → ไปสร้างบัตรล่วงหน้าเพื่อ Gen รหัส</li>
      </ol>
    </div>

    <div class="bg-white/95 dark:bg-slate-900/95 rounded-2xl shadow-xl border border-slate-100/50 dark:border-slate-800/50 p-6 space-y-4">
      <div class="rounded-xl border border-amber-200 dark:border-amber-800/50 bg-amber-50/60 dark:bg-amber-950/20 p-3 text-xs">
        <p *ngIf="scope()?.groupName" class="font-bold text-amber-900 dark:text-amber-100">{{ scope()?.groupName }}</p>
        <p class="text-amber-800/90 dark:text-amber-200/90 mt-1">
          ร้านในฟอร์มตามขอบเขตกลุ่ม
          <span *ngIf="!scope()?.clientIds?.length"> (ทั้งลาน)</span>
        </p>
        <p *ngIf="!canManageFreeCards" class="text-rose-600 font-bold mt-2">ไม่มีสิทธิ์จัดการบัตรจอดฟรี — ตรวจสอบไม่ได้</p>
      </div>

      <div>
        <label class="text-xs font-bold text-slate-500 uppercase">ร้าน / Client *</label>
        <select [(ngModel)]="clientId" [disabled]="!canManageFreeCards || isValidating()"
          class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2.5 bg-white dark:bg-slate-900 font-medium">
          <option [ngValue]="0">— เลือกร้าน —</option>
          <option *ngFor="let c of scopedClients" [ngValue]="c.id">{{ c.name }}</option>
        </select>
      </div>

      <div>
        <label class="text-xs font-bold text-slate-500 uppercase">Subscription จอดฟรี *</label>
        <select [(ngModel)]="subscriptionId" (ngModelChange)="onSubscriptionChange()"
          [disabled]="!canManageFreeCards || isValidating()"
          class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2.5 bg-white dark:bg-slate-900 font-medium">
          <option [ngValue]="0">— เลือก Subscription —</option>
          <option *ngFor="let s of scopedSubscriptions" [ngValue]="s.id">
            {{ s.name }}<span *ngIf="s.vehicleTypeName"> · {{ s.vehicleTypeName }}</span>
          </option>
        </select>
        <p class="text-[11px] text-slate-400 mt-1">ประเภทรถจะถูกตั้งจาก Subscription อัตโนมัติ</p>
      </div>

      <div *ngIf="subscriptionId > 0"
        class="rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 px-3 py-2.5 text-sm">
        <span class="text-xs font-bold text-slate-400 uppercase">ประเภทรถ</span>
        <div class="font-bold text-slate-800 dark:text-slate-100 mt-0.5">{{ vehicleTypeName || '—' }}</div>
      </div>

      <div>
        <label class="text-xs font-bold text-slate-500 uppercase">จำนวนบัตร *</label>
        <input type="number" min="1" [(ngModel)]="qty" [disabled]="!canManageFreeCards || isValidating()"
          class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2.5 bg-white dark:bg-slate-900 font-medium" />
      </div>

      <div>
        <label class="text-xs font-bold text-slate-500 uppercase">หมายเหตุ</label>
        <input type="text" [(ngModel)]="remark" [disabled]="!canManageFreeCards || isValidating()"
          placeholder="ไม่บังคับ"
          class="mt-1 w-full rounded-xl border border-slate-200 dark:border-slate-700 px-3 py-2.5 bg-white dark:bg-slate-900" />
      </div>

      <button type="button" (click)="onValidate()" [disabled]="!canSubmit"
        class="w-full px-5 py-3 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold disabled:opacity-50 transition-colors">
        {{ isValidating() ? 'กำลังตรวจสอบ...' : 'ตรวจสอบโควต้า' }}
      </button>
    </div>
  </div>
</div>

<!-- Result popup (success / fail from API) -->
<div *ngIf="resultPopup as r" class="fixed inset-0 z-[9999] flex items-center justify-center p-4">
  <div class="absolute inset-0 bg-slate-950/60 backdrop-blur-md" (click)="closeResultPopup()"></div>
  <div class="relative w-full max-w-md bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 p-6 md:p-8"
    (click)="$event.stopPropagation()">
    <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full mb-5"
      [ngClass]="r.ok ? 'bg-emerald-50 dark:bg-emerald-900/30' : 'bg-rose-50 dark:bg-rose-900/30'">
      <span class="material-icons text-3xl"
        [ngClass]="r.ok ? 'text-emerald-500' : 'text-rose-500'">
        {{ r.ok ? 'check_circle' : 'error_outline' }}
      </span>
    </div>

    <h3 class="text-xl font-black text-center text-slate-800 dark:text-white mb-2">{{ r.title }}</h3>
    <p class="text-sm text-center text-slate-500 dark:text-slate-400 mb-5 whitespace-pre-line">{{ r.message }}</p>

    <div class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 p-4 text-sm space-y-2 mb-6">
      <div class="flex justify-between gap-3">
        <span class="text-slate-400 font-bold text-xs uppercase">ร้าน</span>
        <span class="font-bold text-slate-800 dark:text-slate-100 text-right">{{ r.clientName }}</span>
      </div>
      <div class="flex justify-between gap-3">
        <span class="text-slate-400 font-bold text-xs uppercase">Subscription</span>
        <span class="font-bold text-slate-800 dark:text-slate-100 text-right">{{ r.subscriptionName }}</span>
      </div>
      <div class="flex justify-between gap-3">
        <span class="text-slate-400 font-bold text-xs uppercase">ประเภทรถ</span>
        <span class="font-bold text-slate-800 dark:text-slate-100 text-right">{{ r.vehicleTypeName }}</span>
      </div>
      <div class="flex justify-between gap-3">
        <span class="text-slate-400 font-bold text-xs uppercase">จำนวนที่ตรวจ</span>
        <span class="font-bold text-slate-800 dark:text-slate-100">{{ r.qty }}</span>
      </div>
      <div *ngIf="r.ok && r.remaining != null" class="flex justify-between gap-3 pt-2 border-t border-slate-200 dark:border-slate-700">
        <span class="text-emerald-600 font-bold text-xs uppercase">โควต้าคงเหลือหลังตัด</span>
        <span class="font-black text-emerald-600 text-lg">{{ r.remaining }}</span>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <button *ngIf="r.ok" type="button" (click)="goCreateAdvance()"
        class="w-full py-3 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold transition-colors">
        ไปสร้างบัตรล่วงหน้า
      </button>
      <button type="button" (click)="closeResultPopup()"
        class="w-full py-3 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
        {{ r.ok ? 'ปิด' : 'ตกลง' }}
      </button>
    </div>
  </div>
</div>

<app-pss-alert-modal
  *ngIf="showAlert"
  [title]="alertTitle"
  [message]="alertMessage"
  [variant]="alertVariant"
  (close)="closeAlert()">
</app-pss-alert-modal>
